<template>
  <footer class="main-footer">
      <div class="container">
        <div class="row">
          <div class="col-xl-7 col-md-6 col-12">
            <ul class="social-list list-inline">
                <li class="list-inline-item">
                  <a href="https://www.facebook.com/WeddingSongsTWN/?fref=ts&pnref=story" target="_blink"><i class="fa fa-facebook"></i></a> <span class="sr-only">facebook</span>
                </li>
                <li class="list-inline-item"><a href="#"><i class="fa fa-instagram"></i></a> <span class="sr-only">instagram</span></li>
                <li class="list-inline-item"><a href="#"><i class="fa fa-twitter"></i></a> <span class="sr-only">twitter</span></li>
            </ul>
            <p class="copyright-txt small">
              Copyright © 2017 weddingsung.com. All Rights Reserved.
            </p>
          </div>
          <div class="col-xl-5 col-md-6 col-12 align-self-end">
            <p class="copyright-txt copyright-cc clearfix">
              <a class="pull-left" rel="license" href="http://creativecommons.org/licenses/by-nc-sa/4.0/">
                <img alt="創用 CC 授權條款" style="border-width:0" src="https://i.creativecommons.org/l/by-nc-sa/4.0/88x31.png" />
              </a>
              <a class="pull-left small" rel="license" href="http://creativecommons.org/licenses/by-nc-sa/4.0/">本著作係採用 創用 CC 姓名標示-非商業性-相同方式分享 4.0 國際 授權條款授權.</a>
            </p>
          </div>
        </div>
      </div>
  </footer>
</template>

<script>
export default {
  name: 'footbar',
  data () {
    return {
      msg: 'Footer'
    }
  }
}
</script>



// WEBPACK FOOTER //
// Footbar.vue?50b8e3a6